import { render, staticRenderFns } from "./addAGoodsMenu.vue?vue&type=template&id=51c75909"
import script from "./addAGoodsMenu.vue?vue&type=script&lang=js"
export * from "./addAGoodsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports